import React, { Component, useState, useEffect } from "react";
import Lottie from "react-lottie-player";
import InformationCard from "./investorCard";
import logo from "../images/logo.png";
import more_arrow from "../images/more_arrow.svg";
import toastSuccess from "../images/toastSuccess.svg";
import toastError from "../images/toastError.svg";
import toastWarning from "../images/toastWarning.svg";
import plus from "../images/plus.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import Dock from "react-dock";
import FadeIn from "react-fade-in";
import { Redirect, Link } from "react-router-dom";
import history from "../history";
import Expand from "react-expand-animated";
import { useAuth } from "../contexts/AuthContext";
import { useQuery, gql, useLazyQuery } from "@apollo/client";
import {
  LOAD_DATA,
  SEARCH_KEYWORD,
  GET_FILTERS,
  APPLY_FILTERS,
  GET_BOOKMARKS_LIST,
  GET_BOOKMARKED_ITEMS,
  GET_INVESTOR_DATA_BY_IDS,
} from "../GraphQL/Queries";
import { useWindowDimensions } from "../contexts/WindowDimension";
import lottieJson from "../images/loadingBlack.json";

function InvestorCardsWrapper() {
  //region variables
  const toastMessageTime = 1600;
  const [loadingText, setLoadingText] = useState("Looking for results...");
  const [loadingAnim, setLoadingAnim] = useState(true);
  const [screenMode, setScreenMode] = useState("normal");
  const [page, setPage] = useState(1);
  const [filterPage, setFilterPage] = useState(1);
  const [searchPage, setSearchPage] = useState(1);
  const [bookmarkPage, setBookmarkPage] = useState(1);
  const [investorIdsList, setInvestorIdsList] = useState([]);
  const [pageData, setPageData] = useState([]);
  const updatePageData = (data) => {
    setPageData(data);
    if (data.length === 0) {
      setLoadingText("No results found");
    } else {
      setLoadingText("Looking for results...");
    }
  };
  const [currPageData, setCurrPageData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [menuVisible, setMenuVisible] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [bookmarkListVisible, setBookmarkListVisible] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const [bookmarkShowList, setBookmarkShowList] = useState(false);
  const [bookmarkListItems, setBookmarkListItems] = useState([
    "List 1",
    "List 2",
    "List 3",
  ]);
  const [filterMode, setFilterMode] = useState(0);
  const [bookmarkListState, setBookmarkListState] = useState("list"); // list, newListInput, removedMsg, addedMsg
  const [currentIdToBookmark, setCurrentIdToBookmark] = useState("");
  const [currentList, setCurrentList] = useState("");
  const [currentInvestor, setCurrentInvestor] = useState("");
  const [listName, setListName] = useState("");
  const [filterType, setFilterType] = useState([]);
  const [filterSector, setFilterSector] = useState([]);
  const [filterLocation, setFilterLocation] = useState([]);
  const [filterStage, setFilterStage] = useState([]);
  const [typeTags, setTypeTags] = useState([]);
  const [sectorTags, setSectorTags] = useState([]);
  const [stageTags, setStageTags] = useState([]);
  const [locationTags, setLocationTags] = useState([]);
  // 0->normal, 1->search, 2->filter, 3->bookmark_page
  const [resultsMode, setResultsMode] = useState(0);
  const [querySearchKey, setQuerySearchKey] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastVisible, setToastVisible] = useState(false);
  const toastDetails = {
    success: { color: "#EDFFEA", icon: toastSuccess },
    error: { color: "#FFE1E1", icon: toastError },
    warning: { color: "#FFF5DC", icon: toastWarning },
  };
  const {
    currentUser,
    logout,
    currentUserData,
    createBookMarkList,
    addToBookMarksList,
    removeFromBookMarksList,
    getBookmarkList,
    subscribed,
  } = useAuth();
  const { width, height } = useWindowDimensions();
  const [getMainInvestorData] = useLazyQuery(LOAD_DATA, {
    variables: {
      page: page,
    },
    onCompleted: (data) => {
      if (resultsMode === 0) {
        updatePageData([...pageData, ...data.getInvestorDataByPage]);
      }
    },
  });
  const [queryGetDataByIds] = useLazyQuery(GET_INVESTOR_DATA_BY_IDS, {
    variables: {
      idList: investorIdsList,
      page: bookmarkPage,
    },
    onCompleted: (data) => {
      console.log("GET_INVESTOR_DATA_BY_IDS", data);
      if (data && data.getInvestorDataByIds) {
        updatePageData([...pageData, ...data.getInvestorDataByIds]);
      }
    },
  });
  const [querySearchResults] = useLazyQuery(SEARCH_KEYWORD, {
    variables: {
      keyword: querySearchKey,
      page: searchPage,
    },
    onCompleted: (data) => {
      console.log("SEARCH_KEYWORD : ", data);
      if (data && data.searchByKeyword && resultsMode === 1) {
        updatePageData([...pageData, ...data.searchByKeyword]);
      }
    },
  });
  const queryFilterTagsResults = useQuery(GET_FILTERS());
  const [queryFilterSearchResults] = useLazyQuery(APPLY_FILTERS, {
    variables: {
      filterType: filterType,
      filterSector: filterSector,
      filterStage: filterStage,
      filterLocation: filterLocation,
      page: filterPage,
    },
    onCompleted: (data) => {
      console.log("APPLY_FILTERS : ", data);
      if (data && data.filterData && resultsMode === 2) {
        updatePageData([...pageData, ...data.filterData]);
      }
    },
  });
  //endregion
  // --------------------------------------------------------------------------------------------------------
  useEffect(() => {
    document.documentElement.style.setProperty("--background", "#000");
    window.onunload = function () {
      document.documentElement.style.setProperty("--background", "#fff");
    };
  }, []);

  useEffect(() => {
    if (subscribed === 1) {
    }
  }, [subscribed]);

  useEffect(() => {
    if (queryFilterTagsResults && queryFilterTagsResults.data) {
      if (queryFilterTagsResults.data.getTypeFilters) {
        setTypeTags(queryFilterTagsResults.data.getTypeFilters);
      }
      if (queryFilterTagsResults.data.getStageFilters) {
        setStageTags(queryFilterTagsResults.data.getStageFilters);
      }
      if (queryFilterTagsResults.data.getSectorFilters) {
        setSectorTags(queryFilterTagsResults.data.getSectorFilters);
      }
      if (queryFilterTagsResults.data.getLocation) {
        setLocationTags(queryFilterTagsResults.data.getLocation);
      }
    }
  }, [queryFilterTagsResults]);

  useEffect(() => {
    if (width < 1220) {
      setScreenMode("mobile");
    } else {
      setScreenMode("normal");
    }
  }, [width]);

  useEffect(() => {
    if (currentUserData !== null) {
      if ("bookmarkLists" in currentUserData) {
        setBookmarkListItems(currentUserData.bookmarkLists);
      }
      getMainInvestorData();
    }
  }, [currentUserData]);

  const divideDataToPages = () => {
    switch (resultsMode) {
      // 0->normal, 1->search, 2->filter, 3->bookmark_page
      case 0:
        setPage(page + 1);
        break;
      case 1:
        setSearchPage(searchPage + 1);
        break;
      case 2:
        setFilterPage(filterPage + 1);
        break;
      case 3:
        setBookmarkPage(filterPage + 1);
        break;
    }
  };

  const searchWithKeyword = () => {
    if (searchKeyword.trim().length > 0) {
      setPageData([]);
      setPage(1);
      setSearchPage(1);
      setResultsMode(1);
      setQuerySearchKey(searchKeyword);
      querySearchResults();
    }
  };

  const applyFilters = () => {
    let type_tags_checked = [];
    let sector_tags_checked = [];
    let location_tags_checked = [];
    let stage_tags_checked = [];
    let checkboxes = document.querySelectorAll("input[type=checkbox]:checked");

    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].id.slice(0, 4) === "Type") {
        type_tags_checked.push('"' + checkboxes[i].value + '"');
      } else if (checkboxes[i].id.slice(0, 6) === "Sector") {
        sector_tags_checked.push('"' + checkboxes[i].value + '"');
      } else if (checkboxes[i].id.slice(0, 8) === "Stage") {
        location_tags_checked.push('"' + checkboxes[i].value + '"');
      } else if (checkboxes[i].id.slice(0, 5) === "Location") {
        stage_tags_checked.push('"' + checkboxes[i].value + '"');
      }
    }
    if (
      type_tags_checked.length > 0 ||
      sector_tags_checked.length > 0 ||
      stage_tags_checked.length > 0 ||
      location_tags_checked.length > 0
    ) {
      setPageData([]);
      setResultsMode(2);
      setFilterType(type_tags_checked);
      setFilterSector(sector_tags_checked);
      setFilterStage(stage_tags_checked);
      setFilterLocation(location_tags_checked);
      queryFilterSearchResults();
    }
  };

  const clearFilters = () => {
    let checkboxes = document.querySelectorAll("input[type=checkbox]:checked");

    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
    setSearchKeyword("");
    setPage((page) => (page === 1 ? 2 : 1));
    setFilterPage(1);
    setSearchPage(1);
    setPageData([]);
    setResultsMode(0);
    getMainInvestorData();
  };

  const bookmarksPage = (list) => {
    setBookmarkShowList(false);
    setMenuVisible(false);
    setBookmarkPage(1);
    // loadBookmarksData();
    setPageData([]);
    setResultsMode(3);
    setCurrentList(list);
    setInvestorIdsList(getBookmarkList(list));
    queryGetDataByIds();
  };

  const showFilters = () => {
    setFiltersVisible(!filtersVisible);
  };

  const checkBookmarkList = (investorId) => {
    let ret = "";
    if (currentUserData !== null) {
      if ("userBookmarks" in currentUserData) {
        Object.keys(currentUserData.userBookmarks).forEach((list) => {
          if (
            investorId in currentUserData.userBookmarks[list] &&
            currentUserData.userBookmarks[list][investorId] === true
          ) {
            ret = list;
          }
        });
      }
    }
    return ret;
  };

  const addToastMessage = (message, type) => {
    let icon = toastDetails.success.icon;
    switch (type) {
      case "success":
        icon = toastDetails.success.icon;
        break;
      case "error":
        icon = toastDetails.error.icon;
        break;
      case "warning":
        icon = toastDetails.warning.icon;
        break;
    }
    setToastMessage(message);
    document.getElementsByClassName("toast-message")[0].style.background =
      toastDetails.success.color;
    document.getElementsByClassName("toast-message-img")[0].src = icon;
    setToastVisible(true);
    setTimeout(() => {
      setToastVisible(false);
    }, toastMessageTime);
  };

  const addListThenBookmark = (newItem) => {
    setBookmark(newItem);
  };

  const bookmarkItem = (id, isBookmarked, investorName) => {
    setCurrentIdToBookmark(id);
    setCurrentInvestor(investorName);
    if (isBookmarked) {
      let temp = checkBookmarkList(id);
      console.log("unbookmark", temp);
      if (temp !== "") {
        setCurrentList(temp);
        removeFromBookMarksList(temp, id);
        // setBookmarkShowList(true);
        // setBookmarkListVisible(true);
        // setBookmarkListState("removedMsg");
        setBookmarkShowList(false);
        setBookmarkListVisible(false);
        addToastMessage(
          investorName + " has been removed from  " + currentList,
          "success"
        );
      }
    } else {
      setBookmarkShowList(true);
      setBookmarkListVisible(true);
    }
  };

  const setBookmark = (list) => {
    setCurrentList(list);
    addToBookMarksList(list, currentIdToBookmark);

    // setBookmarkShowList(true);
    // setBookmarkListVisible(true);
    // setBookmarkListState("addedMsg");
    setBookmarkShowList(false);
    setBookmarkListVisible(false);
    addToastMessage(
      currentInvestor + " has been added to " + currentList,
      "success"
    );
    setTimeout(() => {
      exitMenu();
    }, toastMessageTime);
  };

  const convertTags = (listToConvert, dictionary) => {
    let convertedData = [];

    listToConvert.forEach((element) => {
      dictionary.forEach((dict) => {
        if (dict["id"] == element) {
          convertedData.push(dict["value"]);
        }
      });
    });
    return convertedData;
  };

  const dataPage = () => {
    if (pageData.length === 0 || loadingAnim) {
      return (
        <div className="no-results">
          <center>
            {loadingText === "Looking for results..." ? (
              <>
                <Lottie
                  loop
                  animationData={lottieJson}
                  play
                  onLoopComplete={() => {
                    console.log("animation complete");
                    if (pageData.length !== 0) {
                      setLoadingAnim(false);
                    }
                  }}
                  style={{ width: 150, height: 150 }}
                />
                <span
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Gathering the data
                </span>
              </>
            ) : currentList ? (
              loadingText + " in " + currentList
            ) : (
              loadingText
            )}
          </center>
        </div>
      );
    }
    return pageData.map((investor, idx) => (
      <InformationCard
        useWindow={false}
        key={investor["ID"]}
        id={investor["ID"]}
        name={investor["Name"]}
        location={investor["Location"] === "N/A" ? "N/A" : investor["Location"]}
        headquarters={
          investor["HeadQuarters"] === "N/A" ? "" : investor["HeadQuarters"]
        }
        contact_website={investor["Website"]}
        sectorTags={
          investor["Preferred_Sector"] === "N/A" ||
          !investor["Preferred_Sector"]
            ? []
            : convertTags(investor["Preferred_Sector"], sectorTags)
        }
        typeTags={
          investor["Type"] === "N/A" || !investor["Type"]
            ? []
            : convertTags(investor["Type"], typeTags)
        }
        stageTags={
          investor["Stage"] === "N/A" || !investor["Stage"]
            ? []
            : convertTags(investor["Stage"], stageTags)
        }
        contact_call={investor["Phone"]}
        linkedIn={investor["LinkedIn"]}
        contact_mail={investor["Email"]}
        bookmarkItem={(id, isBookmarked, investorName) =>
          bookmarkItem(id, isBookmarked, investorName)
        }
        img_url={investor["Photo"]}
      />
    ));
  };

  const searchEnterPress = (event) => {
    if (event.key === "Enter" && searchKeyword.trim().length > 0) {
      searchWithKeyword();
    }
  };

  const filterWrapper = (modeNumber, tagsArray, title, forMobile) => {
    return (
      <React.Fragment>
        <span
          className="filter-title"
          onClick={() =>
            filterMode === modeNumber
              ? setFilterMode(0)
              : setFilterMode(modeNumber)
          }
        >
          {title}
          <a
            className={
              filterMode === modeNumber ? "arrow-icon open" : "arrow-icon"
            }
          >
            <span className="left-bar"></span>
            <span className="right-bar"></span>
          </a>
        </span>

        <Expand
          styles={{ open: { height: "35%" } }}
          open={filterMode === modeNumber}
          transitions={["height", "opacity"]}
          duration={200}
        >
          <div className="filter-wrapper">
            <div className="filter-container">
              <ul>
                {tagsArray.map((tag, key) => (
                  <li key={key}>
                    <label htmlFor={title + tag.id}>
                      <input
                        style={{ marginRight: "5px" }}
                        type="checkbox"
                        id={title + tag.id}
                        name={tag.id}
                        value={tag.id}
                      />
                      {tag.value}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Expand>
      </React.Fragment>
    );
  };

  const exitMenu = () => {
    setMenuVisible(false);
    setBookmarkListVisible(false);
    setBookmarkShowList(false);
    setBookmarkListState("list");
  };

  const exitFilter = () => {
    setFiltersVisible(false);
  };

  // --------------------------------------------------------------------------------------------------------
  if (redirect) {
    console.log(redirect);
    history.push(redirect);
    return (
      <Redirect
        to={{
          pathname: redirect,
        }}
      />
    );
  }
  if (screenMode === "normal") {
    return (
      <div id="dashboard-root">
        <div
          className={
            toastVisible
              ? "toast-message-wrapper toast-come-up"
              : "toast-message-wrapper"
          }
        >
          <div className="toast-message">
            <img className="toast-message-img" src="" />
            <div className="toast-message-text">
              <span>{toastMessage}</span>
            </div>
          </div>
        </div>
        <div className="top-bar-wrappper">
          <span className="website-title" onClick={() => clearFilters()}>
            <img src={logo} />
          </span>
          <ul className="top-bar-links">
            <li>
              <div onClick={() => setRedirect("/")}>
                <i className="fa fa-home" />
                <span className="menu-options-title">Home</span>
              </div>
            </li>
            <li>
              <div onClick={() => setBookmarkShowList(true)}>
                <i className="fa fa-bookmark-o" />
                <span className="menu-options-title">Bookmarks</span>
              </div>
            </li>
            <li>
              <div onClick={() => setRedirect("/cards")}>
                <i className="fa fa-credit-card"></i>
                <span className="menu-options-title">Payments</span>
              </div>
            </li>
            <li>
              <Link
                to="/signout"
                style={{
                  color: "white",
                  textDecoration: "unset",
                  margin: "0",
                  padding: "0",
                }}
              >
                <i className="fa fa-sign-out"></i>
                <span className="menu-options-title">Logout</span>
              </Link>
            </li>
          </ul>
        </div>

        <div className="left-sidebar-wrapper">
          <div className="search-wrapper">
            <input
              id="searchBar"
              type="text"
              value={searchKeyword}
              placeholder="Search.."
              className={
                searchKeyword.length > 0
                  ? "search-input search-icon-right"
                  : "search-input search-icon-left"
              }
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyPress={searchEnterPress}
            />
          </div>
          <div
            className={
              searchKeyword.length > 0
                ? "search-button search-button-visible"
                : "search-button"
            }
            onClick={searchWithKeyword}
          >
            search keyword
          </div>
          <div className="filter-main-title">Filters</div>
          <div className="all-filter-wrapper">
            {filterWrapper(1, typeTags, "Type", false)}
            {/* {filterWrapper(2, sectorTags, "Sector", false)} */}
            {filterWrapper(3, stageTags, "Stage", false)}
            {filterWrapper(4, locationTags, "Location", false)}

            <div className="filter-buttons">
              <button onClick={() => clearFilters()}>Clear</button>
              <button onClick={() => applyFilters()}>Apply</button>
            </div>
          </div>
        </div>

        <FadeIn>
          <InfiniteScroll
            dataLength={pageData.length}
            next={() => divideDataToPages()}
            hasMore={true}
            className="card-wrapper"
            style={
              loadingAnim || pageData.length === 0
                ? {
                    height: "60vh",
                    alignItems: "center",
                  }
                : { overflow: "hidden", height: "auto" }
            }
          >
            {dataPage()}
          </InfiniteScroll>
          <div
            style={{
              width: "100%",
              height: "100px",
            }}
          ></div>
        </FadeIn>

        <Dock
          className="hamburger-menu"
          position="right"
          fluid={true}
          size={1}
          dimStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 0.8)" }}
          isVisible={bookmarkShowList}
        >
          <div>
            <h1 className="menu-title">Fundme</h1>
            <span
              className="sub-menu-title"
              onClick={() => setBookmarkShowList(false)}
            >
              <img src={more_arrow} className="back-arrow" />
              Bookmarks
            </span>

            {bookmarkListItems.map((item, key) => {
              return (
                <div className="list-options-wrapper" key={key}>
                  <div onClick={() => bookmarksPage(item)}>
                    <span className="list-options-title">{item}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </Dock>
        <Dock
          className="hamburger-menu"
          position="right"
          fluid={true}
          size={1}
          dimStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 0.8)" }}
          isVisible={bookmarkListVisible}
        >
          {bookmarkListState === "list" ? (
            <div>
              <h1 className="menu-title">Fundme</h1>
              <span className="sub-menu-title" onClick={() => exitMenu()}>
                <img src={more_arrow} className="back-arrow" />
                Select a list to add the investor to
              </span>
              {bookmarkListItems.map((item, key) => {
                return (
                  <div className="list-options-wrapper" key={key}>
                    <div onClick={() => setBookmark(item)}>
                      <span className="list-options-title">{item}</span>
                    </div>
                  </div>
                );
              })}
              <div className="menu-options-wrapper">
                <span
                  className="list-options-add"
                  onClick={() => setBookmarkListState("newListInput")}
                >
                  <img src={plus} className="add-plus" /> Add a new list
                </span>
              </div>
            </div>
          ) : bookmarkListState === "newListInput" ? (
            <div>
              <div className="message-background">
                <div className="message-title">
                  Enter a name for the bookmark list
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    addListThenBookmark(listName);
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter a name for the bookmark list"
                    value={listName}
                    onChange={(e) => setListName(e.target.value)}
                    className="new-list-name-input"
                  />
                  <input type="submit" />
                </form>
              </div>
            </div>
          ) : null}

          <div className="close-menu">
            <span onClick={() => exitMenu()}>
              <i className="fa fa-times"></i>
            </span>
          </div>
        </Dock>
      </div>
    );
  } else {
    return (
      <div className="dashboard-root">
        <div
          className={
            toastVisible
              ? "toast-message-wrapper toast-come-up"
              : "toast-message-wrapper"
          }
        >
          <div className="toast-message">
            <img className="toast-message-img" src="" />
            <div className="toast-message-text">
              <span>{toastMessage}</span>
            </div>
          </div>
        </div>
        <div className="top-bar-wrappper">
          <span className="website-title" onClick={() => clearFilters()}>
            Fundme
          </span>
          <span
            onClick={() => setMenuVisible(!menuVisible)}
            className="menu-button"
          >
            <i className="fa fa-bars" />
          </span>
        </div>
        <div className="mobile-bottom-background">
          <div className="search-wrapper">
            <input
              id="searchBar"
              type="text"
              value={searchKeyword}
              placeholder="Search.."
              className={
                searchKeyword.length > 0
                  ? "search-input search-icon-right"
                  : "search-input search-icon-left"
              }
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyPress={searchEnterPress}
            ></input>
            <span className="filter-button" onClick={() => showFilters()}>
              <i className="fa fa-filter" />
            </span>
          </div>
        </div>

        <FadeIn>
          <InfiniteScroll
            dataLength={pageData.length}
            next={() => divideDataToPages()}
            hasMore={true}
            className="card-wrapper"
          >
            {dataPage()}
          </InfiniteScroll>
          <div
            style={{
              width: "100%",
              height: "100px",
            }}
          ></div>
        </FadeIn>

        <Dock
          className="filters-menu"
          position="bottom"
          fluid={true}
          size={0.7}
          dimStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 0.8)" }}
          isVisible={filtersVisible}
        >
          <div className="filters-wrapper">
            {filterWrapper(1, typeTags, "Type", true)}
            {filterWrapper(2, sectorTags, "Sector", true)}
            {filterWrapper(3, stageTags, "Stage", true)}
            {filterWrapper(4, locationTags, "Location", true)}

            <div className="filter-buttons">
              <button onClick={() => applyFilters()}>Apply</button>
              <button onClick={() => clearFilters()}>Clear</button>
            </div>
            <div className="close-menu">
              <span onClick={() => exitFilter()}>
                {" "}
                <i className="fa fa-times"></i>{" "}
              </span>
            </div>
          </div>
        </Dock>

        <Dock
          className="hamburger-menu"
          position="right"
          fluid={true}
          size={1}
          dimStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 0.8)" }}
          isVisible={menuVisible}
        >
          {bookmarkShowList ? (
            <div>
              <h1 className="menu-title">Fundme</h1>
              <span
                className="sub-menu-title"
                onClick={() => setBookmarkShowList(false)}
              >
                <img src={more_arrow} className="back-arrow" />
                Bookmarks
              </span>

              {bookmarkListItems.map((item, key) => {
                return (
                  <div className="list-options-wrapper" key={key}>
                    <div onClick={() => bookmarksPage(item)}>
                      <span className="list-options-title">{item}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <h1 className="menu-title">Fundme</h1>
              <div className="menu-spacer-1"></div>
              <div className="menu-options-wrapper">
                <div
                  //  onClick={() => bookmarksPage()}
                  onClick={() => setRedirect("/")}
                >
                  <i className="fa fa-home" />
                  <span className="menu-options-title">Home</span>
                </div>
              </div>
              <div className="menu-options-wrapper">
                <div onClick={() => setBookmarkShowList(true)}>
                  <i className="fa fa-bookmark-o" />
                  <span className="menu-options-title">Bookmarks</span>
                </div>
              </div>
              <div className="menu-options-wrapper">
                <div onClick={() => setRedirect("/cards")}>
                  <i className="fa fa-credit-card"></i>
                  <span className="menu-options-title">Payments</span>
                </div>
              </div>

              <div className="menu-spacer-2"></div>
              <div className="menu-options-wrapper">
                <div onClick={() => logout()}>
                  <i className="fa fa-sign-out"></i>
                  <span className="menu-options-title">Logout</span>
                </div>
              </div>
            </div>
          )}

          <div className="close-menu">
            <span onClick={() => exitMenu()}>
              <i className="fa fa-times"></i>
            </span>
          </div>
        </Dock>

        <Dock
          className="hamburger-menu"
          position="right"
          fluid={true}
          size={1}
          dimStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
          dockStyle={{ background: "rgba(20, 20, 20, 0.8)" }}
          isVisible={bookmarkListVisible}
        >
          {bookmarkListState === "list" ? (
            <div>
              <h1 className="menu-title">Fundme</h1>
              <span className="sub-menu-title" onClick={() => exitMenu()}>
                <img src={more_arrow} className="back-arrow" />
                Select a list to add the investor to
              </span>
              {bookmarkListItems.map((item, key) => {
                return (
                  <div className="list-options-wrapper" key={key}>
                    <div onClick={() => setBookmark(item)}>
                      <span className="list-options-title">{item}</span>
                    </div>
                  </div>
                );
              })}
              <div className="menu-options-wrapper">
                <span
                  className="list-options-add"
                  onClick={() => setBookmarkListState("newListInput")}
                >
                  <img src={plus} className="add-plus" /> Add a new list
                </span>
              </div>
            </div>
          ) : bookmarkListState === "newListInput" ? (
            <div>
              <div className="message-background">
                <div className="message-title">
                  Enter a name for the bookmark list
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    addListThenBookmark(listName);
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter a name for the bookmark list"
                    value={listName}
                    onChange={(e) => setListName(e.target.value)}
                    className="new-list-name-input"
                  />
                  <input type="submit" />
                </form>
              </div>
            </div>
          ) : null}

          <div className="close-menu">
            <span onClick={() => exitMenu()}>
              <i className="fa fa-times"></i>
            </span>
          </div>
        </Dock>
      </div>
    );
  }
}

export default InvestorCardsWrapper;
